import { createContext, useContext } from 'react';

import type { PlatformModalHostApi } from './platform-modal-host.types';

export const PlatformModalHostContext = createContext<PlatformModalHostApi | undefined>(undefined);

export function usePlatformModalHost(): PlatformModalHostApi {
    const context = useContext(PlatformModalHostContext);
    if (!context) {
        throw new Error('usePlatformModalHost must be used within PlatformModalHost');
    }
    return context;
}
